
import { Suspense } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import PageLoader from './components/base/PageLoader';

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <Suspense fallback={<PageLoader />}>
        <AppRoutes />
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
